var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrx(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1097_580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 45C34.9265 45 45 34.9265 45 22.5C45 10.0736 34.9265 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 34.9265 10.0736 45 22.5 45Z",
    fill: "#FF060A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8419 13.9411L10.5469 10.2061L21.2273 37.0823L36.1097 18.9501L30.8419 13.9411ZM30.5156 15.5864L33.6206 18.5381L25.1297 20.0751L30.5156 15.5864ZM23.2847 19.7672L14.3353 12.345L28.9631 15.0366L23.2847 19.7672ZM22.6477 21.0806L21.188 33.1462L13.32 13.342L22.6477 21.0806ZM23.9977 21.7205L33.4013 20.0189L22.6153 33.1575L23.9977 21.7205Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1097_580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrx);
export default __webpack_public_path__ + "static/media/trx.e76d7e9a9113797f324347e8055ddce3.svg";
export { ForwardRef as ReactComponent };